import React from "react";

const Dateday = ({dateDay}) => {
    return dateDay;
};

export default Dateday;
